import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const loop = ['Path found', 'Fix recommended', 'Ticket created', 'Remediation done', 'Validation re-run', 'Risk verified closed', 'Evidence stored'];
const outcomes = [{
  label: 'FIXED',
  color: '#22c55e',
  desc: 'Risk fully closed. Evidence captured.'
}, {
  label: 'STILL EXPOSED',
  color: '#ef4444',
  desc: 'Remediation did not close the risk.'
}, {
  label: 'REOPENED',
  color: '#f97316',
  desc: 'Was fixed, now exposed again.'
}, {
  label: 'INCONCLUSIVE',
  color: '#a78bfa',
  desc: 'More information needed to verify.'
}];
export function Verification() {
  return <section id="verification" className="relative w-full py-32 border-t border-white/5" data-id="element-1376">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1377">
        <SectionLabel number="11" label="Fix Verification" className="mb-8" data-id="element-1378" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-1379">
          <div className="lg:col-span-8" data-id="element-1380">
            <SectionHeading size="xl" data-id="element-1381">
              Closed tickets are
              <br data-id="element-1382" />
              <span className="text-white/40" data-id="element-1383">not closed risk.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-1384">
            <p className="text-base text-white/60 leading-relaxed" data-id="element-1385">
              Most security tools stop when a finding is created. Periscan
              closes the loop and turns remediation from an assumption into
              proof.
            </p>
          </div>
        </div>

        {/* Loop — editorial list */}
        <div className="mb-20" data-id="element-1386">
          <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4]/60 mb-8" data-id="element-1387">
            The Loop
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0" data-id="element-1388">
            {loop.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.04
          }} className="flex items-center gap-6 py-5 border-b border-white/5" data-id="element-1389">
                <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-1390">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p className="text-base font-medium text-white" data-id="element-1391">{step}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Outcomes — editorial list */}
        <div data-id="element-1392">
          <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4]/60 mb-8" data-id="element-1393">
            Verification Outcomes
          </p>
          <div className="flex flex-col" data-id="element-1394">
            {outcomes.map((o, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: i * 0.06
          }} className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-6 border-b border-white/5 last:border-0" data-id="element-1395">
                <div className="md:col-span-3 flex items-center" data-id="element-1396">
                  <span className="font-mono text-xs uppercase tracking-widest" style={{
                color: o.color
              }} data-id="element-1397">
                    {o.label}
                  </span>
                </div>
                <div className="md:col-span-9 flex items-center" data-id="element-1398">
                  <p className="text-base text-white/60 leading-relaxed" data-id="element-1399">
                    {o.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}